import * as React from 'react'
import { connect } from 'react-redux'
import Carousel, { CarouselProvider } from '../carousel'
import Button from '@doordash/component-button'
import { Spacing, InlineChildren } from '@doordash/design-language'
import {
  CompleteAnOrder,
  AcceptAnOrder,
  GetSupport,
  StartADash,
} from './Slides'
import * as events from '../../../events'
import * as actions from '../../../actions'
import styled from 'styled-components'
import { get } from 'lodash'
import i18n from '../../../i18n'
import { i18nKeys } from 'translationTypes'

import {
  DD_READY_FIRST_DASH_TS,
  INSTANT_DASH_SPLASH_SUB,
} from '../../../constants'
import LinkButton from '../../atoms/link-button'
import SimpleStore from '../../../utilities/SimpleStore'
import routes from '../../../routes'
import { TrackPayload, SlideDecks } from './tracking'
import { EventActions } from '../../../typeModules/events'

export type ReduxProps = {
  uniqueLink?: string
  closeInAppEducation?: (uniqueLink: string) => Promise<void>
  trackWebviewClosed?: () => Promise<void>
  track?: (data: TrackPayload) => Promise<void>
}

type InAppEducationV4Props = ReduxProps & React.ComponentPropsWithoutRef<'div'>

const SlideContainer = styled.div`
  padding: ${Spacing.Small}px;
  overflow-y: scroll;
`

const InAppEducationV4: React.FC<InAppEducationV4Props> = ({
  closeInAppEducation,
  uniqueLink,
  trackWebviewClosed,
  track,
  ...props
}) => {
  React.useEffect(() => {
    // On load, track the first slide
    track({
      action: EventActions.Rendered,
      deck: SlideDecks.StartADash,
    })
  }, [track])

  const GetStartedButton = () => (
    <LinkButtonWrapper>
      <LinkButton
        type={Button.Types.PrimaryPill}
        size={Button.Sizes.Large}
        tag="a"
        href={routes.webview.buildPath({
          sub: INSTANT_DASH_SPLASH_SUB,
        })}
        onClick={() => {
          SimpleStore.set(DD_READY_FIRST_DASH_TS, Date.now())
          track({
            action: EventActions.Clicked,
            deck: SlideDecks.GetSupport,
          })
          trackWebviewClosed()
          closeInAppEducation(uniqueLink)
        }}
      >
        {i18n.t(i18nKeys.common__getStarted)}
      </LinkButton>
    </LinkButtonWrapper>
  )

  return (
    <SlideContainer>
      <CarouselProvider>
        <Carousel
          onSwipe={(_, elem) =>
            track({
              action: EventActions.Rendered,
              deck: (elem && elem.id) || elem,
            })
          }
        >
          <div id={SlideDecks.StartADash}>
            <StartADash index={0} {...props} />
          </div>
          <div id={SlideDecks.AcceptAnOrder}>
            <AcceptAnOrder index={1} {...props} />
          </div>
          <div id={SlideDecks.CompleteAnOrder}>
            <CompleteAnOrder index={2} {...props} />
          </div>
          <div id={SlideDecks.GetSupport}>
            <GetSupport
              index={3}
              isFooterHidden={false}
              renderFooterContent={() => (
                <InlineChildren
                  justifyContent={InlineChildren.Justification.Center}
                >
                  <GetStartedButton />
                </InlineChildren>
              )}
              {...props}
            />
          </div>
        </Carousel>
      </CarouselProvider>
    </SlideContainer>
  )
}

const LinkButtonWrapper = styled.div`
  padding: ${Spacing.Small}px;
  width: 100%;
`

const mapStateToProps = state => ({
  uniqueLink: get(state, 'application.uniqueLink'),
})

const mapDispatchToProps = {
  trackWebviewClosed: events.trackWebviewClosed,
  closeInAppEducation: actions.closeInAppEducation,
  track: events.trackInAppEducationNavigated,
}

export default connect(mapStateToProps, mapDispatchToProps)(InAppEducationV4)
